import type { StyleRule } from '@archipro-design/aria';
import { pxToRem, pxArrayToRem } from '@archipro-design/aria';

export const DirectoryGridContainer: StyleRule = () => ({
    position: 'relative',
    gridRow: 'span 2',
    width: '100%',
    height: '100%',
    margin: 'auto',
});

export const PotmDetails: StyleRule = () => ({
    margin: pxArrayToRem([18, 0]),
});

export const PotmTitle: StyleRule = ({ theme }) => ({
    ...theme.siteVariables.textStyles.Text.Medium65,
    marginBottom: pxToRem(2),
    color: theme.siteVariables.colors.primitive.black,
    lineHeight: 1.3,
});

export const ProTitle: StyleRule = () => ({
    color: '#717171',
    lineHeight: 1.3,
});

export const VideoAspect: StyleRule<{
    tileHeight: number;
}> = ({ tileHeight }) => ({
    position: 'relative',
    height: pxToRem(tileHeight),
    width: '100%',
    borderRadius: '0.625rem',
    overflow: 'hidden',
});

export const Cover: StyleRule<{ playing: boolean; tileHeight: number }> = ({
    playing,
    tileHeight,
}) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    opacity: playing ? 0 : 1,
    transition: 'opacity 200ms linear 200ms',
    [`&::after`]: {
        content: '" "',
        display: `block`,
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        background: `rgba(0, 0, 0, 0.2)`,
    },
    [`& > img`]: {
        width: '100%',
        height: pxToRem(tileHeight),
        top: 0,
        left: 0,
    },
});

export const Player: StyleRule = () => ({
    position: 'absolute',
    left: 0,
    top: 0,
    height: '100%',
    width: '100%',
    [`& video`]: {
        objectFit: 'fill',
    },
});

export const PlayerMobile: StyleRule = () => ({
    height: pxToRem(300),
    width: pxToRem(300),
});

export const DirectoryGridContainerMobile: StyleRule = () => ({
    display: 'block',
    height: pxToRem(300),
});

export const VideoAspectMobile: StyleRule = () => ({
    position: 'relative',
    height: pxToRem(300),
    width: pxToRem(300),
    margin: '0 auto',
});

export const CoverMobile: StyleRule<{ playing: boolean }> = ({ playing }) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    opacity: playing ? 0 : 1,
    transition: 'opacity 200ms linear 200ms',
    [`& > img`]: {
        width: '100%',
        height: 'auto',
        top: 0,
        left: 0,
    },
});
